<template>
<!--  0:未开始 1：进行中 2：待开奖 3：已开奖-->
	<div class="newProductItem" :class="{'red': productItem.status == 1, 'orange': productItem.status == 2, 'yellow': productItem.status == 3, 'cyan': productItem.status == 0}" @click="productItemClick">
    <div class="product">
      <img v-lazy="productItem.image">
      <span class="f12">{{productItem.time}}{{productItem.status == 0 ? '开始' : '截止'}}</span>
    </div>
    <div class="flex-js-ac">
      <span class="integralnum f14 flex-ac">
        <img src="/static/images/newproducttrial/new_product-icon-money@2x.png">
        <i class="f10">x</i>{{productItem.point}}
      </span>
      <span class="f10 gray">{{productItem.applynum}}人已申请</span>
    </div>
    <div class="name f14 over-ell-1">{{productItem.title}}</div>
    <div class="btn flex-js-ac">
      <span class="f12 color-FC0324">限量{{productItem.limitnum}}份</span>
      <button class="f12">{{productItem.status == 0 ? '即将开始' : productItem.status == 1 ? '立即申请' : productItem.status == 2 ? '待开奖' : '已开奖'}}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'newProductItem',
  props: {
    productItem: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  methods: {
    productItemClick () {
      this.$router.push({
        path: '/newproductdetail',
        query: {
          id: this.productItem.actid
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.newProductItem {
  background: #ffffff;
  padding: 0.1rem 0.11rem;
  border-radius: 0.08rem;
  &.red {
    .product span {
      background: #FC0324;
    }
    .btn button {
      background: #FC0324;
    }
  }
  &.orange {
    .product span {
      background: #FB6E38;
    }
    .btn button {
      background: #FB6E38;
    }
  }
  &.yellow {
    .product span {
      background: #FFB346;
    }
    .btn button {
      background: #FFB346;
    }
  }
  &.cyan {
    .product span {
      background: #20CBA1;
    }
    .btn button {
      background: #20CBA1;
    }
  }
  .product {
    position: relative;
    >img {
      width: 100%;
      height: 1.5rem;
      border-radius: 0.08rem;
      margin-bottom: 0.05rem;
    }
    span {
      position: absolute;
      left: 0;
      bottom: 0;
      color: #ffffff;
      display: block;
      border-radius: 0 0.08rem 0 0.08rem;
      padding: 0.03rem 0.1rem;
      /*opacity: 0.9;*/
    }
  }
  .gray {
    color: #6C6C6C;
  }
  .integralnum {
    color: #FB6E38;
    img {
      width: 0.14rem;
      height: 0.14rem;
    }
    i {
      font-style: normal;
    }
  }
  .name {
    color: #303030;
    font-weight: bold;
    margin: 0.07rem 0 0.08rem;
  }
  .btn {
    button {
      height: 0.27rem;
      width: 0.72rem;
      outline: none;
      border-width: 0;
      border-radius: 0.14rem;
      color: #ffffff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/newProductItem.vue